import React from 'react';

import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { AuthorTypeOptionsWithRealtor } from '@search/filter-enums/enums/AuthorTypeOptions';
import { CheckboxGroup2 } from '../../common/CheckboxGroup2';
import { AuthorFilter } from '../../../models/Filter';

interface ISellerFilter {
    filter: AuthorFilter;
    handleChange: (filter: AuthorFilter) => void;
    classNameGroup?: string;
    isSecond?: boolean;
}

const OPTIONS: OptionType<AuthorTypeOptionsWithRealtor>[] = [
    { label: 'Собственник', value: AuthorTypeOptionsWithRealtor.OWNER },
    { label: 'Застройщик', value: AuthorTypeOptionsWithRealtor.DEVELOPER },
    { label: 'Агент', value: AuthorTypeOptionsWithRealtor.AGENCY },
];

export const SellerFilter: React.FC<ISellerFilter> = ({
    filter,
    handleChange,
    classNameGroup,
    isSecond
}) => {
    const onChange = React.useCallback((value) => {
        handleChange(new AuthorFilter(value));
    }, [ handleChange ]);

    return (
        <CheckboxGroup2
            value={filter.author}
            onChange={onChange}
            mode='check'
            name='SellerFilter'
            classNameGroup={classNameGroup}
            withoutGrid
            isFilter
        >
            {OPTIONS.filter(option => {
                if (isSecond) return option.value !== AuthorTypeOptionsWithRealtor.DEVELOPER;

                return true;
            }).map(({ value, label }) => (
                <Checkbox
                    variant='filter'
                    key={value}
                    name={value}
                >
                    {label}
                </Checkbox>
            ))}
        </CheckboxGroup2>
    );
};
